import React from 'react'

const { Provider, Consumer } = React.createContext()

export { Provider, Consumer }
